<template>
  <div class="table-wrapper">
    <div v-if="productsTable.length !== 0">
      <!-- <v-simple-table fixed-header height="300px" class="table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">UserId</th>
              <th class="text-left">Products Saved Count</th>
              <th class="text-left">Amount Saved</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in productsTable" :key="item.id">
              <td>{{ item[0].listId ? item[0].listId : "Unknown User" }}</td>
              <td>{{ item.length }}</td>
              <td>{{ getSum(item) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table> -->
      <v-data-table
        :headers="headers"
        :items="productsTable"
        :items-per-page="5"
        hide-default-footer
        class="elevation-1"
      ></v-data-table>
    </div>
    <div v-else class="no-products">
      <p class="notify">
        Welcome to your <span class="emphasize">users</span> dashboard.<br />
        Here you can learn about your
        <span class="emphasize-1">potential</span>
        <span class="emphasize"> customers</span>.<br />
        <br />
        Shopdrop users will get <span class="emphasize-1">discount</span>
        notifications so they
        <span class="emphasize">return</span> quickly...
      </p>
    </div>
  </div>
</template>
<script>
import groupBy from "lodash.groupby";
export default {
  name: "merchantUsers",
  data() {
    return {
      headers: [
        {
          text: "UserId",
          align: "start",
          value: "user",
        },
        { text: "Products Saved Count", value: "count" },
        { text: "Amount Saved", value: "amount" },
      ],
    };
  },
  props: {
    merchantProducts: {
      type: Array,
    },
  },
  methods: {
    getSum(items) {
      let sum = 0.0;
      items.forEach((element) => {
        sum += parseFloat(element.price.value);
      });
      return sum;
    },
  },
  computed: {
    productsTable() {
      const items = [];
      const productsByListId = groupBy(this.merchantProducts, "listId");
      Object.values(productsByListId).forEach((products) => {
        items.push({
          user: products[0].listId ? products[0].listId : "Unknown User",
          count: products.length,
          amount: `${this.getSum(products)} ₪`,
        });
      });

      return items;
    },
  },
};
</script>
<style scoped>
.card {
  flex-direction: column;
}
.table-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
}
.table {
  height: 450px;
}
.theme--light.v-data-table {
  border: #dcdcdc40;
}
.odd {
  background-color: whitesmoke;
}
.top-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  margin-right: 0.5%;
  margin-left: 0.5%;
  margin-top: 1%;
  margin-bottom: 1%;
  max-width: 320px;
}
.wrapper {
  width: 100%;
  justify-content: center;
  display: flex;
  margin-bottom: 40px;
}
.emphasize {
  font: 500;
  color: rgb(20, 200, 200);
}
.emphasize-1 {
  font: 500;
  color: #ba22cc;
}
.notify {
  font-family: Helvetica Neue;
  font-size: 30px;
  font-weight: 300;
}
.notify-wrapper {
  display: flex;
  align-items: center;
  padding-left: 35px;
}
</style>